export default "__VITE_ASSET__CLBKy_wJ__"